class OntarioObstetricalPrenatalGeneticInvestigations {
    public IsScreeningOffered?: boolean;
    public IntegratedPrenatalScreening11To13Weeks?: boolean;
    public IntegratedPrenatalScreening15To20Weeks?: boolean;
    public IntegratedPrenatalScreeningResult: string;
    public FirstTrimesterCombinedScreening?: boolean;
    public FirstTrimesterCombinedScreeningResult: string;
    public IsMaternalSerumScreening?: boolean;
    public AlphaFetoProtein?: boolean;
    public MaternalSerumScreeningAndAlphaFetoProteinResult: string;
    public IsOfferedCellFreeDNA?: boolean;
    public CellFreeDNAResult: string;
    public IsOfferedChorionicVillusSampling?: boolean;
    public ChorionicVillusSamplingResult: string;
    public IsOfferedOtherGeneticTesting?: boolean;
    public OtherGeneticTestingResult: string;
    public NuchalTranslucency: string;
    public AbnormalPlacentalBiomarkers: string;

    constructor(fields?: Partial<OntarioObstetricalPrenatalGeneticInvestigations>) {
        Object.assign(this, fields);
    }
}

export { OntarioObstetricalPrenatalGeneticInvestigations };
